import { BaseResponse } from '../../api/api.types';
import { User } from '../user/user.types';

export type Consultation = {
  id: number;
  id_entity: number;
  title: string;
  ref: string | null;
  type: ConsultationType;
  NAF_code: string;
  start: Date | null;
  end: Date | null;
  further_description?: string | null;
  attachments?: string | null;
  id_step: number;
  address: string | null;
  city: string | null;
  postalCode: string | null;
  department: string | null;
  region: string | null;
  scope: ConsultationScope;
  is_premium?: number | null;
  is_removed?: boolean;
  created_at: Date;
};

export interface ConsultationMatches {
  id: number;
  id_consultation: number;
  id_PUB: number;
  id_ENT: number;
  status: number;
}

export enum ConsultationType {
  // Service = 'service',
  // Vente = 'vente',
  LesDeux = 'les deux',
  // ***
  TravauxBatiment = 'Travaux de bâtiment',
  TravauxPublics = 'Travaux publics',
  Fournitures = 'Fournitures',
  Services = 'Services',
}

export enum NewConsultationType {
  
}

export enum ConsultationStatus {
  Programmé = 'Programmé',
  Brouillon = 'Brouillon',
  EnCours = 'En cours',
  Cloturé = 'Cloturé',
  Archivé = 'Archivé',
}

export enum ConsultationSteps {
  Init = 'init',
  Prestations = 'prestations',
  Dates = 'dates',
  Terminated = 'terminated',
}

export enum ConsultationScope {
  All = 'all',
  Region = 'reg',
  Department = 'dep',
}

export type ConfirmConsultationResponse = BaseResponse;

export type AddConsultationDatesRequestData = Pick<Consultation, 'start' | 'end' | 'scope'> &
  Partial<Pick<User, 'firstName' | 'lastName' | 'email' | 'phone'>> & {
    visitOnSite?: boolean;
  };
